import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { ElMessage, ElMessageBox } from "element-plus";
import "./styles/index.scss";

import untils from "@/utils/index";

const app = createApp(App);

app.config.globalProperties.$untils = untils;
app.config.globalProperties.$message = ElMessage;
app.config.globalProperties.$msgbox = ElMessageBox;
app.config.globalProperties.$alert = ElMessageBox.alert;
app.config.globalProperties.$confirm = ElMessageBox.confirm;
app.config.globalProperties.$prompt = ElMessageBox.prompt;

app.use(store);
app.use(router);
app.use(ElementPlus, { locale: zhCn });

app.mount("#app");
